const INITIAL_STATE = {
    certified: {
        status: 'done',
        data: []
    }
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'USERS_CERTIFIED_STATUS':
            return {
                    ...state,
                    certified: {
                        ...state.certified,
                        status: action.payload
                    }
                }
        case 'USERS_CERTIFIED_DATA':
            return {
                    ...state,
                    certified: {
                        ...state.certified,
                        data: action.payload
                    }
                }
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/modules/reducers/usersReducer.js